'use client';
import Typography from '@/components/shared/typography/typography.component';
import { generalHighlights, LimitedTimeOffer } from '../../../../public/Images';
import myImageLoader from '@/image.local.loader';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { ITag } from '@/types/cars.types';

interface TFlapperLineProps {
    hasDiscount: boolean;
    discountText: string;
    className?: string;
    tags?: ITag[];
    lang?: AVAILABLE_LANGUAGES;
}

interface TFlapperLineInnerContentProps {
    animationClass: string;
    renderTags: { tag: string; icon: string }[];
}

const FlapperLineInnerContent = ({
    animationClass = '',
    renderTags,
}: TFlapperLineInnerContentProps) => {
    return (
        <div
            className={`absolute top-0 right-0 en:left-0 flex flex-col  ${animationClass} `}
        >
            {renderTags.map(tag => (
                <div
                    className="w-full flex items-center gap-0.5 h-4"
                    key={`${tag.tag}-${animationClass}`}
                >
                    <img
                        src={myImageLoader({
                            src: tag.icon,
                            width: 32,
                            height: 32,
                            quality: 60,
                        })}
                        alt={tag.tag}
                        width={16}
                        height={16}
                        loading={'lazy'}
                        fetchPriority={'low'}
                        className={'mb-0.5 ar:-scale-x-100 aspect-square'}
                    />
                    <Typography
                        variant="caption2Medium"
                        className={'overflow-hidden leading-4'}
                    >
                        {tag.tag}
                    </Typography>
                </div>
            ))}
        </div>
    );
};

export const FlapperLine = ({
    hasDiscount = false,
    discountText,
    className,
    tags = [],
    lang,
}: TFlapperLineProps) => {
    const tagsToRender: any = [
        hasDiscount ? { tag: discountText, icon: LimitedTimeOffer.src } : null,
        ...tags.map(t => ({
            tag: lang === AVAILABLE_LANGUAGES.ar ? t.nameAr : t.nameEn,
            icon: generalHighlights.src,
        })),
    ]
        .filter(Boolean)
        .slice(0, 2);

    return hasDiscount || (tags && tags.length) ? (
        <div className={`relative w-full overflow-hidden h-4 ${className}`}>
            <FlapperLineInnerContent
                renderTags={tagsToRender}
                animationClass={
                    tagsToRender.length == 1 ? '' : ' animate-twoLineFlapV2_1 '
                }
            />
            <FlapperLineInnerContent
                renderTags={tagsToRender}
                animationClass={
                    tagsToRender.length == 1 ? '' : 'animate-twoLineFlapV2_2'
                }
            />
        </div>
    ) : (
        <span></span>
    );
};
